import { useState, useEffect, useCallback } from 'react';
import { getIdentityFiles, getIdentitySummary } from './identity_services';

export const useIdentityFiles = () => {
  const [files, setFiles] = useState([]);
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [filesData, summaryData] = await Promise.all([
        getIdentityFiles(),
        getIdentitySummary(),
      ]);
      setFiles(filesData);
      setSummary(summaryData);
    } catch (err) {
      console.error('Error loading identity files:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addOrUpdateFile = useCallback((fileData) => {
    setFiles(prev => {
      const exists = prev.find(f => f.path === fileData.path);
      if (exists) return prev.map(f => f.path === fileData.path ? { ...f, ...fileData } : f);
      return [...prev, fileData];
    });
  }, []);

  const removeFile = useCallback((path) => {
    setFiles(prev => prev.filter(f => f.path !== path));
  }, []);

  return { files, summary, isLoading, error, refresh: load, addOrUpdateFile, removeFile };
};
